import CommercialAgreementListContainer from './CommercialAgreementListContainer';
import NewCommercialAgreementContainer from './NewCommercialAgreementContainer';

const commercialAgreementRoutes = [
  {
    exact: true,
    path: '/accounts/:aid/commercial-agreements/',
    component: CommercialAgreementListContainer,
  },
  {
    path: '/accounts/:aid/commercial-agreements/new',
    component: NewCommercialAgreementContainer,
  },
];

export default commercialAgreementRoutes;
